export interface Palette {
  id: string
  label: string
  /** Full-page background colour */
  bg: string
  /** Swatch tile colour (slightly more saturated than bg) */
  swatch: string
  /** Selection ring colour */
  ring: string
  /** Foreground / text colour that reads well on this bg */
  text: string
}

export const PALETTES: Palette[] = [
  {
    id: 'white',
    label: 'Clean White',
    bg: '#FDFCFA',
    swatch: '#EDE9E3',
    ring: '#B8B2AA',
    text: '#2D2D2D',
  },
  {
    id: 'green',
    label: 'Sage',
    bg: '#EEF4EE',
    swatch: '#C8DFC8',
    ring: '#7AAD7A',
    text: '#2D2D2D',
  },
  {
    id: 'blue',
    label: 'Sky',
    bg: '#EBF2F8',
    swatch: '#BDD8EE',
    ring: '#5C9EC0',
    text: '#2D2D2D',
  },
  {
    id: 'yellow',
    label: 'Cream',
    bg: '#FBF8EC',
    swatch: '#EEE2B8',
    ring: '#C0A030',
    text: '#2D2D2D',
  },
  {
    id: 'pink',
    label: 'Blush',
    bg: '#FAF0F1',
    swatch: '#EDD0D4',
    ring: '#C07880',
    text: '#2D2D2D',
  },
]
